// project import
import pages from './pages';
import dashboard from './dashboard';
import accounts from './accounts';
import campaignTeam from './campaignTeam';
import sales from './sales';
import elections from './elections';
import finance from './finance';
import settings from './settings';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard, pages, accounts, campaignTeam, elections, finance, settings]
};

export default menuItems;
